import { render, staticRenderFns } from "./DelayedTransferReport.vue?vue&type=template&id=2041f0de"
import script from "./DelayedTransferReport.vue?vue&type=script&lang=js"
export * from "./DelayedTransferReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports